import { hsv2rgb, rgb2hsv } from './functions';

export const createGradient = /* glsl */ `
    ${rgb2hsv}
    ${hsv2rgb}

    #ifndef CREATE_GRADIENT
    #define CREATE_GRADIENT
    // Smooth color interpolation function
    vec3 smoothColorMix(vec3 hsv1, vec3 hsv2, float t) {
        float smoothT = smoothstep(0.0, 1.0, t);
        
        float hueDiff = hsv2.x - hsv1.x;
        if (hueDiff > 0.5) hueDiff -= 1.0;
        if (hueDiff < -0.5) hueDiff += 1.0;
        
        vec3 hsvMix = vec3(
            mod(hsv1.x + hueDiff * smoothT, 1.0),
            mix(hsv1.y, hsv2.y, smoothT),
            mix(hsv1.z, hsv2.z, smoothT)
        );
        
        return hsv2rgb(hsvMix);
    }

    vec3 smoothColorMix(vec3 color1, vec3 color2, float t, bool convertToHsv) {
        if (convertToHsv) {
            vec3 hsv1 = rgb2hsv(color1);
            vec3 hsv2 = rgb2hsv(color2);
            return smoothColorMix(hsv1, hsv2, t);
        } else {
            return smoothColorMix(color1, color2, t);
        }
    }

    // Create smooth gradient from color array
    vec3 createGradient(vec3 colors[5], int colorCount, float t, bool convertToHsv) {
        int segments = colorCount - 1;
        float segmentSize = 1.0 / float(segments);
        int segment = int(t / segmentSize);
        float localT = (t - float(segment) * segmentSize) / segmentSize;
        
        segment = clamp(segment, 0, segments - 1);
        
        return smoothColorMix(colors[segment], colors[segment + 1], localT, convertToHsv);
    }
    #endif
`;
